import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["filter"]

  initialize() {
    this.select()
  }

  select() {
    const queryString = new URLSearchParams(window.location.search);
    const applied_filter = queryString.get('category') || queryString.get('initial');
    if (applied_filter) {
      this.filterTargets.forEach((el, i) => {
        if (applied_filter != el.textContent) {
          el.style.color = 'grey'
        }
      });
    }
  }

}